// src/components/admin/AdminSidebar.js
import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../../assets/css/admin/AdminSidebar.css';
import AppContext from '../../../context/AppContext';

const AdminSidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {storeLoggedInAdmin} = useContext(AppContext);

  const menuItems = [
    {
      section: 'Main',
      items: [
        { id: 'dashboard', icon: '📊', label: 'Dashboard', path: '/admin/dashboard' },
        { id: 'students', icon: '👥', label: 'Students', path: '/students' },
        { id: 'subadmin', icon: '👨‍💼', label: 'Sub Admin', path: '/sub-admin' },
        { id: 'mentors', icon: '👨‍🏫', label: 'Mentors', path: '/mentors' },
         { id: 'subject management', icon: '🏷️', label: 'Subject Management', path: '/admin-subjects' },
        { id: 'groups', icon: '👨‍👩‍👧‍👦', label: 'Admin Study Groups', path: '/admin-study-groups' },
        { id: 'studysessions', icon: '👨‍👩‍👧‍👦', label: ' Study sessions', path: '/study-sessions' }
      ]
    },
    {
      section: 'Content',
      items: [
        { id: 'files', icon: '📁', label: 'Files and Notes', path: '/files-And-Notes' },
      ]
    },
    {
      section: 'Assessment',
      items: [
        { id: 'reports', icon: '📈', label: 'Reports', path: '/reports' }
      ]
    },
    {
      section: 'System',
      items: [
        { id: 'notifications', icon: '🔔', label: 'Notifications', path: '/admin-notifications' },

        // { id: 'settings', icon: '⚙️', label: 'Settings', path: '/admin-settings' }
      ]
    }
  ];

  const isActive = (path) => location.pathname === path;
   
  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      // Clear any stored user data
      localStorage.removeItem('adminEmail');
      localStorage.removeItem('adminPassword');
      // Navigate to login page
      navigate('/admin-login');
    }
  };


  
  useEffect(() => {
    console.log("Sidebar useEffect called");
    const adminData = localStorage.getItem("admin");
    if (adminData) {
      storeLoggedInAdmin(JSON.parse(adminData));
    }
  }, []);

  return (
    <>
      {/* Mobile Toggle Button */}
      <button 
        className="sidebar-toggle" 
        onClick={toggleSidebar}
        aria-label="Toggle Sidebar"
      >
        ☰
      </button>

      {/* Mobile Overlay */}
      <div 
        className={`sidebar-overlay ${isOpen ? 'active' : ''}`}
        onClick={toggleSidebar}
      />

      {/* Sidebar */}
      <aside className={`admin-sidebar ${!isOpen ? 'closed' : ''} ${isOpen ? 'open' : ''}`}>
        {/* Logo */}
        <div className="sidebar-logo">
          <div className="logo-icon">🎓</div>
          <h3>CircleHub</h3>
        </div>

        {/* Navigation Menu */}
        <nav className="sidebar-menu">
          {menuItems.map((section, index) => (
            <div key={index} className="menu-section">
              <div className="menu-section-title">{section.section}</div>
              {section.items.map((item) => (
                <div
                  key={item.id}
                  className={`menu-item ${isActive(item.path) ? 'active' : ''}`}
                  onClick={() => {
                    navigate(item.path);
                    if (window.innerWidth <= 768) toggleSidebar();
                  }}
                >
                  <span className="menu-item-icon">{item.icon}</span>
                  <span className="menu-item-text">{item.label}</span>
                  {item.badge && (
                    <span className="menu-item-badge">{item.badge}</span>
                  )}
                </div>
              ))}
            </div>
          ))}
          <div className="menu-section">
            <div 
              className="menu-item logout-item"
              onClick={handleLogout}
              title="Logout from your account"
            >
              <span className="menu-item-icon">🚪</span>
              <div className="menu-item-content">
                <span className="menu-item-text">Logout</span>
                <span className="menu-item-description">Sign out</span>
              </div>
            </div>
          </div>
        </nav>

        {/* User Profile */}
        <div className="sidebar-profile">
          <div className="profile-info">
            <div className="profile-avatar">A</div>
            <div className="profile-details">
              <div className="profile-name">Admin User</div>
              <div className="profile-role">Administrator</div>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;